import React, { Component } from 'react'
import { shareFacebook, shareWhatsapp, openNegishut } from "../Services/Sharing"
import "./Header.scss"

export default class Header extends Component {
    render() {
        return (
            <header>
                <div className="header-wrapper">
                    <div className="share">
                        <div onClick={openNegishut} className="ngishut "></div>
                        <div onClick={shareFacebook} className="facebook "></div>
                        <div onClick={shareWhatsapp} className="whatsapp "></div>
                    </div>
                    <div className="sponser">
                        <div className="inter"></div>
                        <div className="toto"></div>
                        <div className="ynet"></div>
                        <div className="yedioth"></div>
                    </div>
                </div>
            </header>
        )
    }
}
